module.exports = __webpack_public_path__ + "img/todo.3610a73e.png";